import { initReactI18next } from 'react-i18next';
import APP_CONSTANTS from '@hkm/constants/app.constants';
import { dayjs } from '@hkm/utils/dayjs-extended';
import i18n from 'i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';

import de from './en.de.json';
import es from './en.es.json';
import fr from './en.fr.json';
import it from './en.it.json';
import ja from './en.ja.json';
import en from './en.json';
import ko from './en.ko.json';
import nl from './en.nl.json';
import pl from './en.pl.json';
import th from './en.th.json';
import tr from './en.tr.json';
import zhHans from './en.zh-Hans.json';
import zhHant from './en.zh-Hant.json';

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
    returnDetails: false;
    returnObjects: false;
  }
}

const detection = {
  // order and from where user language should be detected
  order: [
    'querystring',
    'cookie',
    'localStorage',
    'navigator',
    'htmlTag',
    'path',
    'subdomain'
  ],

  // keys or params to lookup language from
  lookupQuerystring: 'lng',
  lookupCookie: 'i18next',
  lookupLocalStorage: 'i18nextLng',
  lookupFromPathIndex: 0,
  lookupFromSubdomainIndex: 0,

  // cache user language on
  caches: ['localStorage', 'cookie'],
  excludeCacheFor: ['cimode'] // languages to not persist (cookie, localStorage)
};

export const resources = {
  DE: { translation: de, label: 'German' },
  ES: { translation: es, label: 'Spanish' },
  FR: { translation: fr, label: 'French' },
  EN: { translation: en, label: 'English' },
  KO: { translation: ko, label: 'Korean' },
  NL: { translation: nl, label: 'Dutch' },
  PL: { translation: pl, label: 'Polish' },
  TH: { translation: th, label: 'Thai' },
  TR: { translation: tr, label: 'Turkish' },
  JA: { translation: ja, label: 'Japanese' },
  IT: { translation: it, label: 'Italian' },
  'zh-Hans': { translation: zhHans, label: 'Chinese', dateLocale: 'zh-cn' },
  'zh-Hant': {
    translation: zhHant,
    label: 'Traditional Chinese',
    dateLocale: 'zh-cn'
  }
};

registerI18nListeners();

const instance = i18n
  .use(I18nextBrowserLanguageDetector)
  .use(initReactI18next)
  .init({
    returnNull: false,
    returnDetails: false,
    returnObjects: false,
    detection,
    resources,
    fallbackLng: {
      'zh-Hans': ['zh', 'zh-Hant', APP_CONSTANTS.FALLBACK_LANGUAGE],
      default: [APP_CONSTANTS.FALLBACK_LANGUAGE]
    },
    ns: ['translation'],
    defaultNS: 'translation',
    debug: true,
    lng:
      localStorage.getItem(detection.lookupLocalStorage) ||
      APP_CONSTANTS.FALLBACK_LANGUAGE,

    interpolation: {
      escapeValue: false
    }
  });

function registerI18nListeners() {
  i18n.on('languageChanged', lng => {
    dayjs.locale(resources[lng]?.dateLocale || lng);
  });
}

export default instance;



// WEBPACK FOOTER //
// ./src/i18n/index.ts